import React, { useState } from 'react';
import clsx from 'clsx';
import i18n from '@i18n';

function UserAnnouncement({ icon: Icon, title, description, children, lines = null }) {
    const [expanded, setExpanded] = useState(false);
    return (
        <div className="user-announcement-wrap">
            <div className="header">
                <div className="icon-reg">
                    <Icon />
                </div>
                <div className="text">
                    <p>{title}</p>
                    <p
                        className={clsx('message', expanded ? null : lines)}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    {lines && (
                        <a onClick={() => setExpanded(!expanded)}>
                            {expanded ? i18n('rvo.showLess') : i18n('rvo.showMore')}
                        </a>
                    )}
                </div>
            </div>
            <div className="button-wrapper">{children}</div>
        </div>
    );
}

export default UserAnnouncement;
